import { QuestelServicesClient, RequestResult, HttpMethodEnum } from '@questelservices/common';
import store from '@/store';
import { FileParseCalculationDto } from '@/models/file-parsing/FileParseCalculationDto';

export class FileParseCalculationService {
  private client: QuestelServicesClient = new QuestelServicesClient(store, '/api/FileParseCalculations');

  async getAll(): Promise<FileParseCalculationDto[]> {
    return await this.client.get<FileParseCalculationDto[]>('');
  }
}
